import { render } from "./TheCartWidget.vue?vue&type=template&id=f3f15962"
import script from "./TheCartWidget.vue?vue&type=script&lang=js"
export * from "./TheCartWidget.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__